document.querySelectorAll('.portal h3,.tile h3,.tribe h2').forEach(el=>el.dataset.holo=el.textContent.trim());
// frosted galaxy cart / promo drawer
const cartDrawer=document.getElementById('cartDrawer');
const cartOpen=document.getElementById('cartOpen');
const cartCode=document.getElementById('cartCode');
const dealApply=document.getElementById('dealApply');
const couponApply=document.getElementById('couponApply');
const emailOrbit=document.getElementById('emailOrbit');
const portalMusic=document.getElementById('portalMusic');
const portalSound=document.getElementById('portalSound');
document.querySelectorAll('.gbtn').forEach((btn,i)=>{
  btn.style.setProperty('--btnDelay',`${-(i*2.15%11.5).toFixed(2)}s`);
  btn.style.setProperty('--btnSweep',`${-(i*1.7%8.5).toFixed(2)}s`);
  btn.style.setProperty('--btnSpeed',`${(11+(i%5)*1.7).toFixed(1)}s`);
});
function rafThrottle(fn){
  let ticking=false;
  return function(){
    if(ticking)return;
    ticking=true;
    requestAnimationFrame(()=>{ticking=false;fn();});
  };
}
let portalAudioOn=true;
const portalMaxVol=.34;
function setPortalSoundUi(on){
  if(!portalSound)return;
  portalSound.classList.toggle('on',on);
  portalSound.setAttribute('aria-pressed',on?'true':'false');
  portalSound.setAttribute('aria-label',on?'Turn portal sound off':'Turn portal sound on');
}
/* Ray, repeatedly: "still the background music on homepage plays during the
   hero animation."

   Cause: this looked for #void, the old void cinematic. That element was
   removed when the hero became the bb-hero-film section (.bhf), so the lookup
   returned null, the function bailed out with 1 — "hero fully passed" — and
   the bed played at full volume straight over the hero's own soundtrack.

   It now finds whichever hero is actually on the page, and only reports 1 when
   there genuinely is no hero to sit behind. */
function heroPassedAmount(){
  const hero=document.querySelector('.bhf, #void, [data-bhf]');
  if(!hero)return 1;
  const bottom=hero.getBoundingClientRect().bottom;
  const start=innerHeight*.96;
  const end=innerHeight*.72;
  return Math.max(0,Math.min(1,(start-bottom)/(start-end)));
}
function syncPortalMusic(){
  if(!portalMusic||!portalSound)return;
  const ready=heroPassedAmount();
  portalMusic.volume=portalAudioOn?portalMaxVol*ready:0;
  portalSound.classList.toggle('fading',portalAudioOn&&ready<1);
  /* and it may not start itself before the visitor has scrolled at all —
     landing on the page should be the hero's audio and nothing else. */
  if(portalAudioOn&&ready>.05&&scrollY>4&&portalMusic.paused)portalMusic.play().catch(()=>{});
  if(ready<=.02&&!portalMusic.paused)portalMusic.pause();
}
function heroHasResolved(){
  return heroPassedAmount()>=.98;
}
async function startPortalMusic(){
  if(!portalMusic||!portalSound)return;
  portalAudioOn=true;
  portalMusic.muted=false;
  setPortalSoundUi(true);
  portalMusic.volume=portalMaxVol*heroPassedAmount();
  syncPortalMusic();
}
function stopPortalMusic(){
  if(!portalMusic||!portalSound)return;
  portalAudioOn=false;
  portalMusic.pause();
  portalMusic.volume=0;
  setPortalSoundUi(false);
}
if(portalSound)portalSound.addEventListener('click',()=>portalAudioOn?stopPortalMusic():startPortalMusic());
const requestPortalMusicSync=rafThrottle(syncPortalMusic);
window.addEventListener('scroll',requestPortalMusicSync,{passive:true});
window.addEventListener('resize',requestPortalMusicSync);
window.addEventListener('pointerdown',requestPortalMusicSync,{passive:true});
setPortalSoundUi(portalAudioOn);
syncPortalMusic();
function setCartDrawer(open){
  if(!cartDrawer)return;
  cartDrawer.classList.toggle('open',open);
  cartDrawer.setAttribute('aria-hidden',open?'false':'true');
}
if(cartOpen)cartOpen.addEventListener('click',e=>{e.preventDefault();setCartDrawer(true);});
document.querySelectorAll('[data-cart-close]').forEach(el=>el.addEventListener('click',()=>setCartDrawer(false)));
if(dealApply)dealApply.addEventListener('click',()=>{if(cartCode)cartCode.value='2CT22';dealApply.textContent='Applied ✓';setTimeout(()=>dealApply.textContent='Apply deal',1800);});
if(couponApply)couponApply.addEventListener('click',()=>{couponApply.textContent='Locked ✓';setTimeout(()=>couponApply.textContent='Apply',1600);});
if(emailOrbit)emailOrbit.addEventListener('submit',e=>{e.preventDefault();const b=emailOrbit.querySelector('button');if(b){b.textContent='Welcome ✓';setTimeout(()=>b.textContent='Join',1900);}});
addEventListener('keydown',e=>{if(e.key==='Escape')setCartDrawer(false);});
const bruceNav=document.getElementById('bruceNav');
const bruceNavMenu=document.getElementById('bruceNavMenu');
function setBruceNav(open){
  if(!bruceNav||!bruceNavMenu)return;
  bruceNav.classList.toggle('open',open);
  bruceNavMenu.classList.toggle('open',open);
  bruceNav.setAttribute('aria-expanded',open?'true':'false');
}
if(bruceNav)bruceNav.addEventListener('click',e=>{e.stopPropagation();setBruceNav(!bruceNav.classList.contains('open'));});
if(bruceNavMenu)bruceNavMenu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>setBruceNav(false)));
addEventListener('click',e=>{if(bruceNav&&bruceNavMenu&&!bruceNav.contains(e.target)&&!bruceNavMenu.contains(e.target))setBruceNav(false);});
addEventListener('keydown',e=>{if(e.key==='Escape')setBruceNav(false);});
function isBruceShowcase(el){
  if(!(el instanceof HTMLElement))return false;
  if(el.closest('.era7-nav,.void,.wordmark,#voidStory'))return false;
  const idClass=((el.id||'')+' '+(el.className||'')+' '+(el.getAttribute('aria-label')||'')).toLowerCase();
  const text=(el.textContent||'').toLowerCase();
  const likelyBruce=idClass.includes('bruce')||text.includes("i'm bruce")||text.includes('im bruce')||text.includes('psst')||text.includes('lost a package');
  if(!likelyBruce)return false;
  const s=getComputedStyle(el);
  if(s.position!=='fixed'&&s.position!=='sticky')return false;
  const r=el.getBoundingClientRect();
  return r.width>24&&r.height>24&&r.right>innerWidth*.35&&r.bottom>innerHeight*.35;
}
function setBruceShowcaseVisibility(){
  const ready=heroHasResolved();
  document.documentElement.classList.toggle('bruce-showcase-ready',ready);
  if(ready){
    document.querySelectorAll('[data-bruce-showcase-hidden="1"]').forEach(el=>{
      el.style.visibility=el.dataset.bruceOldVisibility||'';
      el.style.opacity=el.dataset.bruceOldOpacity||'';
      el.style.pointerEvents=el.dataset.bruceOldPointerEvents||'';
      el.removeAttribute('data-bruce-showcase-hidden');
      delete el.dataset.bruceOldVisibility;
      delete el.dataset.bruceOldOpacity;
      delete el.dataset.bruceOldPointerEvents;
    });
    return;
  }
  setBruceNav(false);
  document.querySelectorAll('body *').forEach(el=>{
    if(!isBruceShowcase(el)||el.dataset.bruceShowcaseHidden==='1')return;
    el.dataset.bruceOldVisibility=el.style.visibility||'';
    el.dataset.bruceOldOpacity=el.style.opacity||'';
    el.dataset.bruceOldPointerEvents=el.style.pointerEvents||'';
    el.dataset.bruceShowcaseHidden='1';
    el.style.visibility='hidden';
    el.style.opacity='0';
    el.style.pointerEvents='none';
  });
}
const requestBruceShowcaseVisibility=rafThrottle(setBruceShowcaseVisibility);
addEventListener('scroll',requestBruceShowcaseVisibility,{passive:true});
addEventListener('resize',requestBruceShowcaseVisibility);
setBruceShowcaseVisibility();
if('MutationObserver' in window){
  new MutationObserver(requestBruceShowcaseVisibility).observe(document.body,{childList:true,subtree:true});
}
// nav frost on scroll
const hdr=document.getElementById('era7-hdr');
function updateHeaderFrost(){if(hdr)hdr.classList.toggle('solid',scrollY>8);}
addEventListener('scroll',rafThrottle(updateHeaderFrost),{passive:true});
updateHeaderFrost();
const navLinks=[...document.querySelectorAll('#hdr nav a,#era7-hdr nav a,.explore-rail a')];
const exploreRail=document.getElementById('exploreRail');
const navSections=[...document.querySelectorAll('#gear,#line,#tribe,#story,#outro')];
function setActiveSection(){
  if(exploreRail)exploreRail.classList.toggle('on',scrollY>innerHeight*.68);
  let active='gear';
  navSections.forEach(sec=>{const r=sec.getBoundingClientRect();if(r.top<innerHeight*.48&&r.bottom>innerHeight*.18)active=sec.id;});
  navLinks.forEach(a=>a.classList.toggle('active',(a.getAttribute('href')||'').slice(1)===active||a.dataset.sec===active));
}
addEventListener('scroll',rafThrottle(setActiveSection),{passive:true});addEventListener('resize',rafThrottle(setActiveSection));setActiveSection();
function openShopMegaMenu(){
  const shopTriggers=[...document.querySelectorAll('summary,a,button,[role="button"]')].filter(el=>{
    const copy=(el.textContent||el.getAttribute('aria-label')||'').replace(/\s+/g,' ').trim().toLowerCase();
    if(copy!=='shop'&&copy!=='shop bearback')return false;
    if(el.closest('.era7-homepage')&&el.matches('[data-open-shop-mega]'))return false;
    return !!(el.offsetWidth||el.offsetHeight||el.getClientRects().length);
  });
  const trigger=shopTriggers[0];
  if(trigger){
    const events=['pointerenter','mouseenter','mouseover','focus'];
    events.forEach(type=>trigger.dispatchEvent(new Event(type,{bubbles:true,cancelable:true})));
    const details=trigger.closest('details');
    if(details)details.setAttribute('open','');
    if(trigger.matches('summary,button,[role="button"]'))trigger.click?.();
    setTimeout(()=>{
      const categoryHeading=[...document.querySelectorAll('body *')].find(el=>(el.textContent||'').replace(/\s+/g,' ').trim().toLowerCase()==='shop by category');
      categoryHeading?.scrollIntoView?.({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest'});
    },80);
    return true;
  }
  const line=document.getElementById('line');
  const lubesTile=document.querySelector('.tile[data-drawer="lubes"]');
  const lubesDrawer=document.getElementById('drawer-lubes');
  if(line&&lubesTile&&lubesDrawer){
    line.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    setTimeout(()=>{
      closeLineDrawers();
      lubesDrawer.classList.add('open');
      lubesDrawer.setAttribute('aria-hidden','false');
      lubesTile.classList.add('portal-open');
    },180);
    return true;
  }
  return false;
}
document.addEventListener('click',e=>{
  const trigger=e.target.closest('[data-open-shop-mega]');
  if(!trigger)return;
  if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
  e.preventDefault();
  openShopMegaMenu();
});
// void scrub
const root=document.documentElement,voidEl=document.getElementById('void');
const vid=document.getElementById('hvid');
const bruceEl=document.getElementById('bruce');
const lines=[...document.querySelectorAll('#voidStory .line')];
const titleLetters=[...document.querySelectorAll('.wordmark span')];
const clamp=(x)=>Math.max(0,Math.min(1,x));
let HP=0;
const touch=false;
if(touch){
  // fallback only; primary experience is scroll-scrubbed so the hero feels like a portal, not a clip
  [vid,bruceEl].forEach(v=>{if(v){v.loop=true;v.muted=true;v.setAttribute('autoplay','');}});
  const vo=new IntersectionObserver(es=>es.forEach(e=>{[vid,bruceEl].forEach(v=>{if(!v)return;e.isIntersecting?v.play().catch(()=>{}):v.pause();});}),{threshold:0.01});
  vo.observe(voidEl);
}else{
  if(vid){
    vid.loop=true;vid.muted=true;vid.setAttribute('autoplay','');
    const playOpening=()=>{if(scrollY<8)vid.play().catch(()=>{});scrub();};
    vid.addEventListener('loadedmetadata',playOpening);
    vid.addEventListener('canplay',playOpening,{once:true});
  }
  if(bruceEl){bruceEl.pause();bruceEl.addEventListener('loadedmetadata',()=>scrub());}
}
function scrub(){if(!voidEl)return;const h=voidEl.offsetHeight-innerHeight;const p=Math.max(0,Math.min(1,scrollY/h));HP=p;
  const heroRect=voidEl.getBoundingClientRect();
  const heroVisible=heroRect.bottom>0&&heroRect.top<innerHeight;
  const sm=(a,z,x)=>{const t=Math.max(0,Math.min(1,(x-a)/(z-a)));return t*t*(3-2*t)};
  const endFade=1-sm(.92,1,p);
  const openingAutoplay=false;
  // moving deep-space base: scrub the rip/bloom film through the first half, then hand off to Bruce
  if(heroVisible&&!touch&&vid&&vid.duration&&!openingAutoplay){try{vid.pause();vid.currentTime=Math.min(vid.duration-0.05, clamp(p/0.5)*vid.duration*0.64);}catch(e){}}
  if(openingAutoplay&&vid&&vid.paused)vid.play().catch(()=>{});
  if(vid)vid.style.opacity=((1-sm(.60,.82,p))*endFade).toFixed(3);
  // Bruce the demigod forms out of the rip and engulfs the dark, then softens as the wordmark resolves
  const br=sm(.42,.62,p)*(1-0.5*sm(.86,1,p));
  if(bruceEl){bruceEl.style.opacity=(br*endFade).toFixed(3);bruceEl.style.setProperty('--brm',(8+sm(.42,.72,p)*44)+'%');bruceEl.style.transform=`scale(${(1.3-sm(.42,.82,p)*0.26).toFixed(3)})`;
    if(heroVisible&&!touch&&bruceEl.duration){const bt=clamp((p-0.42)/(0.9-0.42));try{bruceEl.currentTime=Math.min(bruceEl.duration-0.05,bt*bruceEl.duration);}catch(e){}}}
  // flying story words
  lines.forEach(l=>{const a=+l.dataset.a,b=+l.dataset.b;const t=clamp((p-a)/(b-a));const op=Math.sin(Math.PI*t);const sc=(0.72+t*0.66).toFixed(3);
    l.style.opacity=(op*op).toFixed(3);l.style.transform=`translate(-50%,-50%) scale(${sc})`;});
  // BEARBACK forms as heavy metallic 3D letters from the edges; ERA 7 blooms large behind it
  const wordHold=1-sm(.992,1,p);
  const e=sm(.61,.82,p)*wordHold;                    // metallic light bloom behind title
  const wm=sm(.58,.76,p)*wordHold;                   // BEARBACK 3D letter assembly
  const beam=sm(.62,.84,p)*wordHold;                 // "let there be light" sweep
  const era=sm(.76,.92,p)*wordHold;                  // ERA 7 appears after BEARBACK lands
  const e3=sm(.88,.97,p)*wordHold;                   // welcome copy after the hero resolve lands, then holds
  const g=sm(.76,1,p);                              // tribe → gold shift
  const lp=(a,b)=>Math.round(a+(b-a)*g);
  const wg=`rgba(${lp(0x93,0xff)},${lp(0x3f,0xd9)},${lp(0xff,0x6b)},0.62)`;
  root.style.setProperty('--p',p.toFixed(3));root.style.setProperty('--e',e.toFixed(3));
  root.style.setProperty('--wm',wm.toFixed(3));root.style.setProperty('--era',era.toFixed(3));
  root.style.setProperty('--beam',beam.toFixed(3));root.style.setProperty('--beamX',`${(-28+beam*156).toFixed(1)}%`);
  root.style.setProperty('--e1',wm.toFixed(3));root.style.setProperty('--e2',era.toFixed(3));root.style.setProperty('--e3',e3.toFixed(3));
  titleLetters.forEach((letter,i)=>{const from=+(letter.style.getPropertyValue('--from')||1),lift=+(letter.style.getPropertyValue('--lift')||0);const lt=clamp((wm-i*.025)/.86);const ease=lt*lt*(3-2*lt);
    letter.style.opacity=ease.toFixed(3);
    letter.style.transform=`translate3d(${(from*(1-ease)*34).toFixed(2)}vw,${(lift*(1-ease)*15).toFixed(2)}vh,${((1-ease)*-520).toFixed(1)}px) rotateY(${(from*(1-ease)*82).toFixed(2)}deg) rotateX(${(lift*(1-ease)*34).toFixed(2)}deg) rotateZ(${(from*(1-ease)*-12).toFixed(2)}deg) scale(${(.38+ease*.62).toFixed(3)})`;});
  root.style.setProperty('--g',g.toFixed(3));root.style.setProperty('--wg',wg);}
const requestScrub=rafThrottle(scrub);
addEventListener('scroll',requestScrub,{passive:true});addEventListener('resize',requestScrub);scrub();
/* Ray: "the Bruce animation needs to start as the section is scrolled into."
   This selector required BOTH [autoplay] AND [loop], so any clip that plays
   once — the Bruce animation in the About portal is the obvious one — was
   never handed to the observer at all. It autoplayed on page load, finished
   long before anyone scrolled that far, and sat frozen on its last frame.

   Every autoplaying video is observed now. Looping ones behave as before,
   play on enter and pause on leave. A one-shot rewinds to the start when its
   section arrives, so it plays FOR the person arriving rather than to an
   empty screen. */
const ambientVideos=[...document.querySelectorAll('video[autoplay]')].filter(v=>!['hvid','bruce'].includes(v.id));
if('IntersectionObserver' in window&&ambientVideos.length){
  const videoObserver=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      const video=entry.target;
      if(entry.isIntersecting){
        /* a one-shot starts from the top every time you come back to it */
        if(!video.loop&&video.currentTime>0.05){
          try{video.currentTime=0;}catch(e){}
        }
        video.play?.().catch(()=>{});
      }else{
        video.pause?.();
      }
    });
  },{threshold:.05,rootMargin:'220px 0px'});
  ambientVideos.forEach(video=>{
    video.preload='metadata';
    video.pause?.();
    videoObserver.observe(video);
  });
}
const softenedLoopVideos=[...document.querySelectorAll('.tile[data-drawer="tribeplus"] .tile-media video,.portal[data-soft-loop] video')];
softenedLoopVideos.forEach(video=>{
  const applyLoopFade=()=>{
    const duration=video.duration||0;
    if(!duration||!Number.isFinite(duration))return;
    const fadeIn=Math.min(.65,duration*.16);
    const fadeOut=Math.min(.9,duration*.18);
    const start=Math.min(1,video.currentTime/fadeIn);
    const end=Math.min(1,(duration-video.currentTime)/fadeOut);
    const fade=Math.max(.08,Math.min(start,end,1));
    video.style.opacity=(.34+fade*.52).toFixed(3);
  };
  video.addEventListener('loadedmetadata',applyLoopFade);
  video.addEventListener('timeupdate',applyLoopFade);
  video.addEventListener('seeked',applyLoopFade);
  applyLoopFade();
});
// interactive proof comparison
const receiptStats=[...document.querySelectorAll('.receipt-stat')];
const animateReceiptStats=()=>{
  receiptStats.forEach(card=>{
    if(card.dataset.done)return;
    card.dataset.done='1';
    const strong=card.querySelector('strong');
    const start=Number(card.dataset.start||0);
    const end=Number(card.dataset.count||0);
    const suffix=card.dataset.suffix||'';
    const prefix=card.dataset.prefix||'';
    const t0=performance.now();
    const dur=1050;
    function tick(now){
      const p=Math.min(1,(now-t0)/dur);
      const e=1-Math.pow(1-p,3);
      const val=Math.round(start+(end-start)*e);
      strong.textContent=prefix+val+suffix;
      if(p<1)requestAnimationFrame(tick);else card.classList.add('counted');
    }
    requestAnimationFrame(tick);
  });
};
const statsObserver=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){animateReceiptStats();statsObserver.disconnect();}}),{threshold:.35});
if(receiptStats[0])statsObserver.observe(receiptStats[0]);

const receiptRows=[...document.querySelectorAll('.cmp tbody tr.proof-row')];
receiptRows.forEach((row,i)=>{
  row.style.setProperty('--proofIndex',i);
  const detail=document.createElement('tr');
  detail.className='detail-row';
  detail.innerHTML=`<td colspan="5"><div class="row-detail"><img src="bottle_sm.jpg" alt=""><div><b>Why it matters</b><p>${row.dataset.detail||''}</p></div></div></td>`;
  row.insertAdjacentElement('afterend',detail);
  if(i===0)row.classList.add('active');
  row.addEventListener('mouseenter',()=>{receiptRows.forEach(r=>r.classList.remove('active'));row.classList.add('active');});
  row.addEventListener('click',e=>{
    receiptRows.forEach(r=>{if(r!==row)r.classList.remove('active','open');});
    document.querySelectorAll('.detail-row.open').forEach(d=>{if(d!==detail)d.classList.remove('open');});
    row.classList.add('active');
    if(e.target.closest('.row-plus')||innerWidth<761){
      const open=!row.classList.contains('open');
      row.classList.toggle('open',open);
      detail.classList.toggle('open',open);
    }
  });
});
const rowObserver=new IntersectionObserver(entries=>{
  entries.forEach(e=>{
    if(e.isIntersecting){
      receiptRows.forEach(r=>r.classList.remove('active'));
      e.target.classList.add('active','lit');
    }
  });
},{threshold:.58,rootMargin:'-14% 0px -28% 0px'});
receiptRows.forEach(r=>rowObserver.observe(r));
// review lightbox
const reviewModal=document.getElementById('reviewModal'),reviewClose=document.getElementById('reviewClose');
const reviewTitle=document.getElementById('reviewTitle'),reviewQuote=document.getElementById('reviewQuote'),reviewPerson=document.getElementById('reviewPerson'),reviewKind=document.getElementById('reviewKind');
const reviewStage=document.querySelector('.review-video');
function reviewPlaceholder(kind='Review media'){
  return `<div class="review-placeholder"><b>${kind}</b><span>Real face photo or video drops here. The card is wired; just add the media file.</span></div>`;
}
function renderReviewMedia(target,card,{modal=false}={}){
  if(!target||!card)return;
  const media=(card.dataset.media||'').trim(),poster=(card.dataset.poster||'').trim(),type=(card.dataset.mediaType||'').trim();
  const kind=card.dataset.kind||'Review media';
  if(!media){
    if(modal)target.innerHTML=reviewPlaceholder(kind);
    return;
  }
  if(type==='image'||/\.(png|jpe?g|webp|gif|avif)$/i.test(media)){
    target.innerHTML=`<img src="${media}" alt="${card.dataset.title||'Bearback review media'}" loading="lazy">`;
  }else{
    target.innerHTML=`<video src="${media}" ${poster?`poster="${poster}"`:''} controls playsinline preload="metadata"></video>`;
  }
}
function hydrateReviewCard(card){
  const avatar=(card.dataset.avatar||'').trim(),av=card.querySelector('.av'),rm=card.querySelector('.rm');
  if(avatar&&av){av.innerHTML=`<img src="${avatar}" alt="${card.dataset.person||'Reviewer'}" loading="lazy">`;}
  if(rm){
    const media=(card.dataset.poster||card.dataset.media||'').trim();
    if(media){
      const imageLike=card.dataset.poster||card.dataset.mediaType==='image'||/\.(png|jpe?g|webp|gif|avif)$/i.test(media);
      rm.insertAdjacentHTML('afterbegin',imageLike?`<img src="${media}" alt="${card.dataset.title||'Review'}" loading="lazy">`:`<video src="${media}" muted playsinline preload="metadata"></video>`);
    }
  }
}
function openReview(card){if(!reviewModal)return;reviewTitle.textContent=card.dataset.title||'Bearback review';reviewQuote.textContent=card.dataset.quote||card.querySelector('q')?.textContent||'';reviewPerson.textContent=card.dataset.person||'';reviewKind.textContent=card.dataset.kind||'Review';renderReviewMedia(reviewStage,card,{modal:true});reviewModal.classList.add('open');reviewModal.setAttribute('aria-hidden','false');}
function closeReview(){if(!reviewModal)return;reviewModal.classList.remove('open');reviewModal.setAttribute('aria-hidden','true');}
document.querySelectorAll('.rc').forEach(card=>{
  hydrateReviewCard(card);
  card.addEventListener('click',()=>openReview(card));
  card.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();openReview(card);}});
});
if(reviewClose)reviewClose.addEventListener('click',closeReview);
if(reviewModal)reviewModal.addEventListener('click',e=>{if(e.target===reviewModal)closeReview();});
addEventListener('keydown',e=>{if(e.key==='Escape')closeReview();});
/* ══════════════════════════════════════════════════════════════════════════
   TAPPING A TILE — a rim of light and a push of sound
   Ray: "this sound to play as you click on a tile on the home page, but it's
   faint and faded in and out. Make the tile you click on glow around the
   edges when clicked."

   Two things worth knowing about how this is built:

   1 · The clip is 0.52s and the tiles are links, so a plain click would
       navigate before either the sound or the glow could register. A plain
       left-click therefore holds navigation for 340ms — long enough to read
       as deliberate feedback rather than lag. Modified clicks (cmd, ctrl,
       shift, middle) are left completely alone so open-in-new-tab still works,
       and reduced-motion users navigate immediately.

   2 · The fade is done with Web Audio rather than by stepping .volume on a
       timer, because a ramp on a GainNode is sample-accurate and will not
       stutter while the page is busy laying out a navigation.
   ══════════════════════════════════════════════════════════════════════════ */
(function(){
  var tiles = [].slice.call(document.querySelectorAll('.era7-homepage .tile'));
  if(!tiles.length) return;

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SRC = (window.__bbTilePush || '');
  var ctx = null, buf = null, loading = false;

  /* ── Ray, 2026-08-21: "the website does not load sound by default it seems
     all the time, so i can't tell if it's a bug or other."

     It was a bug, and it had two halves.

     1 · The buffer was fetched on pointerenter and then decoded. Both are
         async, so on the very first tap `buf` was still null and push()
         returned silently — you only ever heard the sound from the SECOND tile
         you clicked onward. On a phone there is no hover at all before the tap,
         so the first tile was always silent, and since a tile navigates away
         there often was no second tap on that page.

     2 · The AudioContext was constructed during a hover. A hover is not a user
         activation, so the context was born `suspended`; resume() is a promise
         and was not awaited before the source was scheduled.

     Fix: warm earlier and from more entry points, build/resume the context
     inside a real gesture (pointerdown), and — when the buffer genuinely has
     not landed yet — fall back to a plain <audio> element, which is allowed to
     play inside a click handler with no decode step. So the first tap makes a
     sound whatever state the loader is in.
     ─────────────────────────────────────────────────────────────────────── */

  /* the fallback element: cheap, created once, never touched unless needed */
  var el = null;
  function elFallback(){
    if(!SRC) return 0;
    try{
      if(!el){
        el = new Audio(SRC);
        el.preload = 'auto';
        el.volume = 0.20;              /* same faintness as the Web Audio peak */
      }
      el.currentTime = 0;
      var p = el.play();
      if(p && p.catch) p.catch(function(){});
      return el.duration && isFinite(el.duration) ? el.duration : 0.52;
    }catch(e){ return 0; }
  }

  /* the buffer is fetched on first intent, not on page load — this sound
     costs nothing to anyone who never taps a tile */
  function warm(){
    if(loading || buf || !SRC) return;
    loading = true;
    try{
      var AC = window.AudioContext || window.webkitAudioContext;
      if(!AC) return;
      ctx = ctx || new AC();
      fetch(SRC).then(function(r){ return r.arrayBuffer(); })
        .then(function(ab){ return ctx.decodeAudioData(ab); })
        .then(function(b){ buf = b; })
        .catch(function(){});
      /* the element is primed alongside so the fallback is instant if the
         decode has not finished by the time the tile is clicked */
      if(!el){ el = new Audio(SRC); el.preload = 'auto'; el.volume = 0.20; }
    }catch(e){}
  }

  /* pointerdown is a real user activation — resume there, not on hover */
  function unlock(){
    warm();
    try{ if(ctx && ctx.state === 'suspended') ctx.resume(); }catch(e){}
  }

  tiles.forEach(function(t){
    t.addEventListener('pointerenter', warm, { once:true, passive:true });
    t.addEventListener('focus', warm, { once:true });
    t.addEventListener('pointerdown', unlock, { passive:true });
    t.addEventListener('touchstart', unlock, { passive:true });
  });
  /* and once for the page, so the very first tile tapped is already warm */
  addEventListener('pointerdown', unlock, { once:true, passive:true });

  function push(){
    if(!buf || !ctx || ctx.state !== 'running') return elFallback();
    try{
      var src = ctx.createBufferSource();
      var gain = ctx.createGain();
      src.buffer = buf;
      src.connect(gain); gain.connect(ctx.destination);

      var t0 = ctx.currentTime;
      var dur = buf.duration;
      var PEAK = 0.20;                 /* faint on purpose */
      var IN   = Math.min(0.09, dur * 0.22);
      var OUT  = Math.min(0.24, dur * 0.5);

      gain.gain.setValueAtTime(0.0001, t0);
      gain.gain.exponentialRampToValueAtTime(PEAK, t0 + IN);
      gain.gain.setValueAtTime(PEAK, t0 + Math.max(IN, dur - OUT));
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);

      src.start(t0);
      src.stop(t0 + dur + 0.02);
      return dur;
    }catch(e){ return 0; }
  }

  tiles.forEach(function(tile){
    tile.addEventListener('click', function(e){
      /* never touch a click the person meant to open somewhere else */
      var modified = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0;

      tile.classList.remove('is-lit');
      void tile.offsetWidth;              /* restart the animation on a re-tap */
      tile.classList.add('is-lit');
      setTimeout(function(){ tile.classList.remove('is-lit'); }, 900);

      warm();
      push();

      if(modified || reduce) return;

      var href = tile.getAttribute('href');
      if(!href || href.charAt(0) === '#') return;
      if(tile.target && tile.target !== '_self') return;

      e.preventDefault();
      setTimeout(function(){ window.location.href = href; }, 340);
    });
  });
})();

// portal parallax
const portals=document.getElementById('portals');
const portalCards=portals?[...portals.querySelectorAll('.portal')]:[];
function clearPortalActive(except){
  portalCards.forEach(card=>{if(card!==except)card.classList.remove('is-active');});
}
portalCards.forEach((card,i)=>{
  card.style.setProperty('--portalIndex',i);
  card.addEventListener('pointermove',e=>{
    const r=card.getBoundingClientRect();
    const mx=(e.clientX-r.left)/r.width-.5;
    const my=(e.clientY-r.top)/r.height-.5;
    card.style.setProperty('--px',`${(50+mx*34).toFixed(1)}%`);
    card.style.setProperty('--py',`${(38+my*28).toFixed(1)}%`);
    card.style.setProperty('--tileRx',`${(-my*5.2).toFixed(2)}deg`);
    card.style.setProperty('--tileRy',`${(mx*7.2).toFixed(2)}deg`);
  });
  card.addEventListener('pointerenter',()=>clearPortalActive(card));
  card.addEventListener('pointerleave',()=>{
    card.style.removeProperty('--px');
    card.style.removeProperty('--py');
    card.style.removeProperty('--tileRx');
    card.style.removeProperty('--tileRy');
  });
  card.addEventListener('pointerdown',()=>{clearPortalActive(card);card.classList.add('is-active');});
  card.addEventListener('focus',()=>{clearPortalActive(card);card.classList.add('is-active');});
  card.addEventListener('blur',()=>card.classList.remove('is-active'));
});
// inline product portals — tile expands in-place and pushes the rest of the line down smoothly
const lineGrid=document.getElementById('lineGrid');
const drawers=[...document.querySelectorAll('.tile-drawer')];
function closeLineDrawers(){
  drawers.forEach(d=>{d.classList.remove('open');d.setAttribute('aria-hidden','true');});
  document.querySelectorAll('.tile[data-drawer]').forEach(t=>t.classList.remove('portal-open'));
  document.querySelectorAll('.mini-product.flipped').forEach(card=>card.classList.remove('flipped'));
}
if(lineGrid){
  lineGrid.addEventListener('click',e=>{
    const close=e.target.closest('[data-close-drawer]');
    if(close){e.preventDefault();closeLineDrawers();return;}
    const productCard=e.target.closest('[data-product-card]');
    if(productCard&&lineGrid.contains(productCard)&&!e.target.closest('a')){
      e.preventDefault();
      productCard.classList.toggle('flipped');
      return;
    }
    const tile=e.target.closest('.tile[data-drawer]');
    if(!tile||!lineGrid.contains(tile))return;
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    const key=tile.dataset.drawer;
    const drawer=document.getElementById(`drawer-${key}`);
    if(!drawer)return;
    e.preventDefault();
    const already=drawer.classList.contains('open');
    closeLineDrawers();
    if(!already){
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden','false');
      tile.classList.add('portal-open');
      const reduceMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;
      setTimeout(()=>drawer.scrollIntoView({behavior:reduceMotion?'auto':'smooth',block:'nearest'}),120);
    }
  });
  lineGrid.addEventListener('keydown',e=>{
    const productCard=e.target.closest('[data-product-card]');
    if(!productCard||!lineGrid.contains(productCard))return;
    if(e.key!=='Enter'&&e.key!==' ')return;
    e.preventDefault();
    productCard.classList.toggle('flipped');
  });
}
// ---- pointer / touch / gyro parallax ----
let px=0,py=0,tx=0,ty=0;
addEventListener('mousemove',e=>{px=(e.clientX/innerWidth-.5)*2;py=(e.clientY/innerHeight-.5)*2;},{passive:true});
addEventListener('touchmove',e=>{const t=e.touches[0];if(t){px=(t.clientX/innerWidth-.5)*2;py=(t.clientY/innerHeight-.5)*2;}},{passive:true});
addEventListener('deviceorientation',e=>{if(e.gamma!=null){px=Math.max(-1,Math.min(1,e.gamma/40));py=Math.max(-1,Math.min(1,(e.beta-40)/40));}},{passive:true});
const sky=document.querySelector('.sky');const secbgs=[...document.querySelectorAll('.secbg')];const tribeGod=document.querySelector('.tribe-god');
(function para(){tx+=(px-tx)*.05;ty+=(py-ty)*.05;
  root.style.setProperty('--glx',`${(50+tx*18).toFixed(1)}%`);
  root.style.setProperty('--gly',`${(34+ty*18).toFixed(1)}%`);
  root.style.setProperty('--tiltSpin',`${(tx*18+ty*10).toFixed(1)}deg`);
  root.style.setProperty('--cardRx',`${(-ty*1.2).toFixed(2)}deg`);
  root.style.setProperty('--cardRy',`${(tx*1.6).toFixed(2)}deg`);
  if(vid)vid.style.transform=`scale(1.05) translate(${(-tx*8).toFixed(1)}px,${(-ty*6).toFixed(1)}px)`;
  if(tribeGod)tribeGod.style.transform=`scale(1.08) translate(${(-tx*18).toFixed(1)}px,${(-ty*12).toFixed(1)}px)`;
  if(sky)sky.style.transform=`scale(1.08) translate(${(-tx*12).toFixed(1)}px,${(-ty*9).toFixed(1)}px)`;
  secbgs.forEach((b,i)=>{b.style.transform=`scale(1.06) translate(${(-tx*(8+i*3)).toFixed(1)}px,${(-ty*6).toFixed(1)}px)`;});
  requestAnimationFrame(para);})();
// ---- formula cinematic chapters ----
const formulaSec=document.querySelector('.formula-sec');
const formulaStage=document.getElementById('formulaStage');
const formulaChapters=[...document.querySelectorAll('.formula-chapter')];
const formulaImages=[...document.querySelectorAll('.formula-image')];
const formulaTray=document.getElementById('formulaTray');
const formulaPlus=document.getElementById('formulaPlus');
const formulaCount=document.getElementById('formulaCount');
let formulaActive=0;
function setFormulaChapter(i){
  if(!formulaChapters.length)return;
  const next=Math.max(0,Math.min(formulaChapters.length-1,i));
  if(next===formulaActive&&formulaImages[next]?.classList.contains('is-active'))return;
  formulaChapters.forEach((ch,idx)=>{
    ch.classList.toggle('is-active',idx===next);
    ch.classList.toggle('is-leaving',idx!==next&&idx===formulaActive);
  });
  formulaImages.forEach((img,idx)=>img.classList.toggle('is-active',idx===next));
  formulaActive=next;
  root.style.setProperty('--formulaIndex',next);
  if(formulaCount)formulaCount.textContent=String(next+1).padStart(2,'0')+' / '+String(formulaChapters.length).padStart(2,'0');
  if(formulaTray){
    const detail=formulaChapters[next].dataset.detail||'';
    const label=(formulaChapters[next].querySelector('.n')?.textContent||'Formula detail').split('·').pop().trim();
    formulaTray.innerHTML='<b>'+label+'</b><p>'+detail+'</p>';
  }
}
function formulaScroll(){
  if(!formulaSec||!formulaChapters.length)return;
  const r=formulaSec.getBoundingClientRect();
  const travel=Math.max(1,r.height-innerHeight);
  const p=Math.max(0,Math.min(1,(-r.top)/travel));
  root.style.setProperty('--formulaP',p.toFixed(3));
  if(r.top<innerHeight&&r.bottom>0)setFormulaChapter(Math.round(p*(formulaChapters.length-1)));
}
formulaPlus?.addEventListener('click',()=>{
  const open=!formulaTray?.classList.contains('open');
  formulaTray?.classList.toggle('open',open);
  formulaPlus.setAttribute('aria-expanded',String(open));
  formulaPlus.textContent=open?'×':'+';
});
addEventListener('scroll',rafThrottle(formulaScroll),{passive:true});
formulaScroll();
// ---- scroll-reveal + orbital drift ----
const revSel='.ey,.big,.intro p,.tile,.receipt-copy,.receipt-stat,.cmp,.rc,.tribe-logo,.tribe h2,.tribe-device,.tribe .man,.tribe-control,.tribe-trust span,.tribe .gbtn,.bruce-nav,.outro img,.outro h2,.outro .cta';
document.querySelectorAll(revSel).forEach(el=>el.classList.add('reveal'));
document.querySelectorAll('.bento,.wall,.bens').forEach(g=>[...g.children].forEach((c,i)=>{if(c.classList.contains('reveal'))c.style.transitionDelay=(i*0.07)+'s';}));
const io=new IntersectionObserver((es)=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}}),{threshold:.14,rootMargin:'0px 0px -8% 0px'});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
const tribeDeviceEarly=document.querySelector('.tribe-device');
if(tribeDeviceEarly){
  const tribePhoneIo=new IntersectionObserver((es)=>es.forEach(e=>{
    if(e.isIntersecting){e.target.classList.add('in');tribePhoneIo.unobserve(e.target);}
  }),{threshold:.01,rootMargin:'0px 0px 34% 0px'});
  tribePhoneIo.observe(tribeDeviceEarly);
}
const driftEls=[...document.querySelectorAll('.portal,.rc,.tribe-device,.tribe-logo')];
const sceneEls=[...document.querySelectorAll('.sec')];
function driftScroll(){
  const maxScroll=Math.max(1,document.documentElement.scrollHeight-innerHeight);
  const depth=Math.max(0,Math.min(1,scrollY/maxScroll));
  root.style.setProperty('--pageDepth',depth.toFixed(3));
  const mid=innerHeight*.52;
  sceneEls.forEach((sec,i)=>{
    const r=sec.getBoundingClientRect();
    const d=((r.top+r.height*.5)-mid)/innerHeight;
    const scene=Math.max(0,1-Math.abs(d)*.72);
    sec.style.setProperty('--scene',scene.toFixed(3));
  });
  driftEls.forEach((el,i)=>{
    const r=el.getBoundingClientRect();
    const d=((r.top+r.height*.5)-mid)/innerHeight;
    const near=Math.max(0,1-Math.abs(d)*1.7);
    const y=(-d*34)+(Math.sin(scrollY*.003+i)*5);
    const s=.965+near*.045;
    el.style.setProperty('--driftY',`${y.toFixed(1)}px`);
    el.style.setProperty('--driftScale',s.toFixed(3));
    el.style.setProperty('--stepNear',near.toFixed(3));
    el.style.opacity=(.68+near*.32).toFixed(3);
    el.style.setProperty('--driftBlur',`${(Math.max(0,Math.abs(d)-.34)*1.15).toFixed(2)}px`);
  });
}
addEventListener('scroll',rafThrottle(driftScroll),{passive:true});addEventListener('resize',rafThrottle(driftScroll));driftScroll();
// TRIBE device console
const tribeSec=document.getElementById('tribe');
const tribeControls=[...document.querySelectorAll('.tribe-control')];
const tribePanels=[...document.querySelectorAll('[data-screen-panel]')];
const tribeCopyline=document.getElementById('tribeCopyline');
// Ray: selecting a pill transforms the whole section — headline + supporting line cross-fade with the phone.
const tribeHeadline=document.getElementById('tribeHeadline');
const tribeHeadA=tribeHeadline?.querySelector('.tribe-h2-a');
const tribeHeadB=tribeHeadline?.querySelector('.tribe-h2-b');
const TRIBE_HEADLINES={
  discover:['Discover your universe.',''],
  nearby:['Your tribe.','No radius.'],
  people:['Real people.','Really nearby.'],
  communities:['Find your rooms.',''],
  chat:['Say it your way.',''],
  cream:['Keep score.',"Or don't."],
  band:['A signal, not a status.',''],
  bruce:['Meet Bruce.','Your AI wingman.']
};
let tribeNarrativeReady=false,tribeSwapTimer=null;
function swapTribeNarrative(screen,copy){
  const head=TRIBE_HEADLINES[screen];
  const apply=()=>{
    // no mapping for this screen: leave the headline exactly as it is
    if(head&&tribeHeadA){
      tribeHeadA.textContent=head[0];
      if(tribeHeadB){
        tribeHeadB.textContent=head[1]||'';
        tribeHeadB.hidden=!head[1];
      }
    }
    if(copy&&tribeCopyline)tribeCopyline.textContent=copy;
  };
  // first render keeps the markup defaults (no flash on load)
  if(!tribeNarrativeReady){tribeNarrativeReady=true;return;}
  if(!head&&!copy)return;
  const fading=[tribeHeadline,tribeCopyline].filter(Boolean);
  if(!fading.length){apply();return;}
  fading.forEach(el=>el.classList.add('is-swapping'));
  clearTimeout(tribeSwapTimer);
  tribeSwapTimer=setTimeout(()=>{
    apply();
    fading.forEach(el=>el.classList.remove('is-swapping'));
  },210);
}
function setTribeScreen(screen){
  if(!tribeSec)return;
  tribeSec.className=tribeSec.className.replace(/\btribe-mode-\S+/g,'').trim()+` tribe-mode-${screen}`;
  tribeControls.forEach(btn=>{
    const on=btn.dataset.screen===screen;
    btn.classList.toggle('active',on);
    btn.setAttribute('aria-pressed',String(on));
    if(on)swapTribeNarrative(screen,btn.dataset.copy);
  });
  tribePanels.forEach(panel=>panel.classList.toggle('active',panel.dataset.screenPanel===screen));
  if(screen==='discover'){
    const discoverPanel=document.querySelector('[data-screen-panel="discover"]');
    const splash=discoverPanel?.querySelector('.tribe-phone-splash');
    discoverPanel?.classList.add('rebooting');
    void discoverPanel?.offsetWidth;
    discoverPanel?.classList.remove('rebooting');
    if(splash){
      try{splash.currentTime=0;splash.play?.();}catch(e){}
    }
  }
}
tribeControls.forEach(btn=>btn.addEventListener('click',()=>setTribeScreen(btn.dataset.screen)));
setTribeScreen('discover');
// starfield (deep TRIBE nebula: layered depth, hard twinkles, faint constellation lines)
const cv=document.getElementById('stars'),cx=cv.getContext('2d');let W,H,DPR=1,st=[],links=[],par=0,T=0,pageDepth=0;
const CO=['#ffffff','#c4b5fd','#a78bfa','#f472b6','#38bdf8','#e9c46a','#d946ef'];
function star(){
  const z=Math.random()**1.7;
  const band=Math.random()<.42;
  return {
    x:Math.random()*W,
    y:band ? H*(.14+Math.random()*.54)+(Math.random()-.5)*Math.sin(Math.random()*Math.PI)*H*.18 : Math.random()*H,
    z,band,
    r:.12+Math.random()*.36+z*.46,
    c:CO[Math.floor(Math.random()*CO.length)],
    t:Math.random()*Math.PI*2,
    vx:(Math.random()-.5)*(.04+z*.095),
    vy:(Math.random()-.5)*(.016+z*.04),
    swirl:Math.random()*.9+.25,
    flare:Math.random()<.035,
    pulse:.65+Math.random()*1.8
  };
}
function rs(){
  DPR=Math.min(2,devicePixelRatio||1);W=innerWidth;H=innerHeight;
  cv.width=Math.floor(W*DPR);cv.height=Math.floor(H*DPR);cv.style.width=W+'px';cv.style.height=H+'px';cx.setTransform(DPR,0,0,DPR,0,0);
  const count=Math.min(300,Math.floor(W*H/6500));
  st=Array.from({length:count},star);links=[];
  for(let i=0;i<st.length;i++){
    if(st[i].z<.5||Math.random()>.32)continue;
    for(let j=i+1;j<st.length&&links.length<count*.42;j++){
      if(st[j].z<.5)continue;
      const dx=st[i].x-st[j].x,dy=st[i].y-st[j].y;
      if(Math.hypot(dx,dy)<130&&Math.random()<.08)links.push([i,j,Math.random()*.5+.5]);
    }
  }
}
function updateDepth(){par=scrollY;pageDepth=Math.max(0,Math.min(1,scrollY/Math.max(1,document.documentElement.scrollHeight-innerHeight)));}
rs();updateDepth();addEventListener('resize',()=>{rs();updateDepth();});addEventListener('scroll',rafThrottle(updateDepth),{passive:true});
function glint(x,y,len,alpha,color){
  const g=cx.createRadialGradient(x,y,0,x,y,len*.5);
  g.addColorStop(0,color);g.addColorStop(.2,`rgba(255,255,255,${alpha})`);g.addColorStop(1,'rgba(255,255,255,0)');
  cx.strokeStyle=g;cx.lineWidth=.45;cx.globalAlpha=alpha;
  cx.beginPath();cx.moveTo(x-len,y);cx.lineTo(x+len,y);cx.moveTo(x,y-len);cx.lineTo(x,y+len);cx.stroke();
}
function nebulaMist(){
  const drift=T*.00145;
  const glow=1-pageDepth*.56;
  cx.save();
  const base=cx.createLinearGradient(0,0,W,H);
  base.addColorStop(0,`rgba(0,0,5,${.12+pageDepth*.18})`);
  base.addColorStop(.45,`rgba(2,5,17,${.08+pageDepth*.12})`);
  base.addColorStop(1,`rgba(0,0,2,${.22+pageDepth*.22})`);
  cx.globalCompositeOperation='source-over';cx.fillStyle=base;cx.fillRect(0,0,W,H);
  cx.globalCompositeOperation='screen';
  const bands=[
    [W*.18+Math.sin(drift*.9)*70,H*.18+Math.cos(drift*1.1)*38,W*.62,H*.22,'147,63,255',.052,-.34],
    [W*.78+Math.cos(drift*.8)*86,H*.25+Math.sin(drift*1.3)*40,W*.56,H*.20,'6,182,212',.044,.28],
    [W*.48+Math.sin(drift*.55)*110,H*.58+Math.cos(drift*.85)*48,W*.92,H*.28,'59,91,255',.047,-.12],
    [W*.28+Math.cos(drift*.72)*70,H*.78+Math.sin(drift*.9)*38,W*.72,H*.22,'255,61,142',.034,.22],
    [W*.58+Math.sin(drift*1.1)*64,H*.86+Math.cos(drift*.62)*30,W*.82,H*.18,'56,189,248',.048,-.08],
    [W*.44+Math.cos(drift*.5)*48,H*.96+Math.sin(drift*.7)*24,W*.62,H*.14,'233,196,106',.028,.08]
  ];
  bands.forEach(([x,y,rx,ry,rgb,a,rot])=>{
    cx.save();cx.translate(x,y);cx.rotate(rot);cx.scale(rx,ry);
    const g=cx.createRadialGradient(0,0,0,0,0,1);
    g.addColorStop(0,`rgba(${rgb},${a*glow})`);
    g.addColorStop(.34,`rgba(${rgb},${a*.42*glow})`);
    g.addColorStop(.62,`rgba(${rgb},${a*.16*glow})`);
    g.addColorStop(1,`rgba(${rgb},0)`);
    cx.fillStyle=g;cx.fillRect(-1,-1,2,2);cx.restore();
  });
  cx.globalCompositeOperation='multiply';
  const lanes=[
    [W*.52+Math.sin(drift*.62)*80,H*.22,W*.96,H*.24,.34,-.08],
    [W*.62+Math.cos(drift*.7)*78,H*.72,W*.98,H*.20,.28,.14],
    [W*.10,H*.52,W*.46,H*.44,.22,.08],
    [W*.94,H*.50,W*.44,H*.48,.24,-.18]
  ];
  lanes.forEach(([x,y,rx,ry,a,rot])=>{
    cx.save();cx.translate(x,y);cx.rotate(rot);cx.scale(rx,ry);
    const g=cx.createRadialGradient(0,0,0,0,0,1);
    g.addColorStop(0,`rgba(0,0,0,${a+pageDepth*.12})`);
    g.addColorStop(.48,`rgba(0,0,0,${a*.48})`);
    g.addColorStop(1,'rgba(0,0,0,0)');
    cx.fillStyle=g;cx.fillRect(-1,-1,2,2);cx.restore();
  });
  cx.globalCompositeOperation='screen';
  for(let i=0;i<4;i++){
    const y=H*(.20+i*.18)+Math.sin(drift*1.4+i)*18;
    const g=cx.createLinearGradient(W*.05,y,W*.95,y+H*.08);
    g.addColorStop(0,'rgba(255,255,255,0)');
    g.addColorStop(.42,`rgba(196,181,253,${.018*glow})`);
    g.addColorStop(.52,`rgba(233,196,106,${.012*glow})`);
    g.addColorStop(1,'rgba(255,255,255,0)');
    cx.globalAlpha=.42;cx.fillStyle=g;cx.fillRect(0,y-3,W,7);
  }
  cx.restore();
}
function deepSpaceStructure(){
  cx.save();
  const glow=1-pageDepth*.66;
  cx.globalCompositeOperation='multiply';
  const abyss=cx.createRadialGradient(W*.50,H*.58,0,W*.50,H*.58,Math.max(W,H)*.78);
  abyss.addColorStop(0,'rgba(0,0,0,0)');
  abyss.addColorStop(.64,`rgba(0,0,0,${.12+pageDepth*.18})`);
  abyss.addColorStop(1,`rgba(0,0,0,${.46+pageDepth*.20})`);
  cx.fillStyle=abyss;cx.fillRect(0,0,W,H);
  cx.globalCompositeOperation='screen';
  const sweep=cx.createLinearGradient(W*.06,H*.76,W*.94,H*.12);
  sweep.addColorStop(0,'rgba(56,189,248,0)');
  sweep.addColorStop(.34,`rgba(56,189,248,${.022*glow})`);
  sweep.addColorStop(.52,`rgba(196,181,253,${.048*glow})`);
  sweep.addColorStop(.68,`rgba(233,196,106,${.018*glow})`);
  sweep.addColorStop(1,'rgba(56,189,248,0)');
  cx.fillStyle=sweep;cx.globalAlpha=.9*glow;cx.fillRect(0,0,W,H);
  const core=cx.createRadialGradient(W*.50,H*.70,0,W*.50,H*.70,Math.max(W,H)*.62);
  core.addColorStop(0,`rgba(56,189,248,${.022*glow})`);
  core.addColorStop(.42,`rgba(147,63,255,${.018*glow})`);
  core.addColorStop(1,'rgba(0,0,0,0)');
  cx.fillStyle=core;cx.globalAlpha=1;cx.fillRect(0,0,W,H);
  cx.restore();
}
function drawConstellations(projected){
  cx.lineWidth=.55;
  for(const [i,j,w] of links){
    const a=projected[i],b=projected[j];if(!a||!b)continue;
    const dx=a.x-b.x,dy=a.y-b.y,dist=Math.hypot(dx,dy);
    if(dist>170)continue;
    const breathe=.5+.5*Math.sin(T*.01+i*.37);
    const al=(1-dist/170)*.18*Math.min(a.z,b.z)*w*(.5+breathe*.5)*(1-pageDepth*.46);
    cx.strokeStyle=`rgba(196,181,253,${al})`;
    cx.beginPath();cx.moveTo(a.x,a.y);cx.lineTo(b.x,b.y);cx.stroke();
  }
}
(function d(ts=0){
  if(d.last&&ts-d.last<45){requestAnimationFrame(d);return;}
  d.last=ts;
  T++;
  cx.clearRect(0,0,W,H);
  nebulaMist();
  deepSpaceStructure();
  const projected=[];
  for(const s of st){
    s.x+=s.vx+Math.sin(T*.002+s.t)*.018*s.swirl;
    s.y+=s.vy+Math.cos(T*.0017+s.t)*.013*s.swirl;
    if(s.x>W+12)s.x=-12;if(s.x<-12)s.x=W+12;if(s.y>H+12)s.y=-12;if(s.y<-12)s.y=H+12;
    const depth=.18+s.z*.95;
    const orbit=Math.sin((s.x/W)*Math.PI+s.t)*H*.025*(s.band?.9:.35);
    const px=((s.x+Math.sin(T*.0015+s.t)*20*depth-par*.012*depth)%(W+20)+W+20)%(W+20)-10;
    const py=((s.y+orbit+Math.cos(T*.001+s.t)*10*depth+par*.0035*depth)%(H+20)+H+20)%(H+20)-10;
    const hard=Math.max(0,Math.sin(T*.055*s.pulse+s.t));
    const slow=.36+.64*Math.sin(T*.012+s.t)**2;
    const tw=(s.flare?Math.pow(hard,10):Math.pow(slow,2.1))*(.28+s.z*.72);
    const rr=s.r*(.68+s.z*.9)*(s.flare?1+hard*.28:1);
    cx.beginPath();cx.arc(px,py,rr,0,7);
    cx.fillStyle=s.c;cx.globalAlpha=Math.min(.82,.10+tw*(.68-pageDepth*.18));
    cx.shadowColor=s.c;cx.shadowBlur=(s.flare?10:4)*s.z*(.35+tw)*(1-pageDepth*.32);
    cx.fill();
    if(s.flare&&hard>.76)glint(px,py,5+13*s.z*hard,.12+.24*hard,s.c);
    projected.push({x:px,y:py,z:s.z});
  }
  drawConstellations(projected);
  cx.globalAlpha=1;cx.shadowBlur=0;cx.globalCompositeOperation='source-over';
  requestAnimationFrame(d);
})();
